// Tests: src/app/migrations/migrations.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V7 → V8
 *
 * Upgrade:
 * - bodenform.suffix === '(G)' → bodenform.reliktG = true, suffix entfernen
 *
 * Downgrade:
 * - bodenform.reliktG === true → bodenform.suffix = '(G)', reliktG entfernen
 *   (Achtung: vorhandener suffix geht verloren)
 */
export const migrationV7ToV8: MigrationDefinition = {
  fromVersion: 7,
  toVersion: 8,

  upgrade(doc: any): any {
    const bf = doc.header?.bodenform;
    if (bf?.suffix === '(G)') {
      bf.reliktG = true;
      delete bf.suffix;
    }

    doc.version = 8;
    return doc;
  },

  downgrade(doc: any): any {
    const bf = doc.header?.bodenform;
    if (bf?.reliktG) {
      // Falls bereits ein Suffix vorhanden ist, geht er verloren
      bf.suffix = '(G)';
      delete bf.reliktG;
    }

    doc.version = 7;
    return doc;
  },

  dataLossWarnings: [
    'Bei Downgrade mit reliktG=true UND vorhandenem Suffix wird der Suffix durch (G) überschrieben'
  ]
};
